const initialState = {
  deals: null,
};

const DealReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DEAL":
      return {
        ...state,
        deals: action.payload,
      };
    default:
      return state;
  }
};

export default DealReducer;
